import { Middleware } from "redux";

import { Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Locale } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

export const rowActionRemoveRowMiddleware: Middleware<unknown, { locale: Locale }> = api => next => action => {
	const result = next(action);

	if (
		FormEngineActions.event.match(action) &&
		Events.Repeat.customRowAction.match(action.payload.engineEvent) &&
		action.payload.engineEvent.payload.eventName === "REMOVE_ROW"
	) {
		api.dispatch(
			FormEngineActions.event({
				activityId: action.payload.activityId,
				engineEvent: Events.Repeat.removeRow(action.payload.engineEvent.payload)
			})
		);
	}

	return result;
};
